import { css, styled } from 'styled-components';
import { Button } from '@vivaahealth/design-system';
import { CARD_DIMENSIONS } from '../../types';

export const Container = styled.div.attrs<{ dragging?: boolean }>((props) => ({
  dragging: props.dragging,
}))`
  border: 1px dashed #bfbfbf;
  border-radius: 4px;
  min-width: 236px;
  flex: 1;
  height: 200px;
  padding: 32px 16px;

  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;

  ${({ dragging }) =>
    dragging &&
    css`
      * {
        pointer-events: none; // Don't allow children to steal drag events
      }
      background-color: var(--color-primary-transparent);
      border-color: var(--color-primary);
    `}

  & > svg {
    align-self: center;
    flex-shrink: 0;
  }
`;

export const UploadedImageContainer = styled(Container)`
  border-style: solid;
  gap: 12px;
`;

export const UploadedImageContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionContainer = styled.div.attrs<{ isDesktop: boolean }>(
  (props) => ({
    isDesktop: props.isDesktop,
  }),
)`
  display: flex;
  gap: 8px;

  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'row-reverse')};
`;

export const StyledCameraButton = styled(Button)`
  padding: 0;
`;

export const StyledUploadButton = styled(Button)`
  & > input {
    display: none;
  }
`;

const IMG_WIDTH = 212;
export const UploadedImage = styled.img`
  align-self: center;
  width: ${IMG_WIDTH}px;
  height: calc(
    ${CARD_DIMENSIONS.height} / ${CARD_DIMENSIONS.width} * ${IMG_WIDTH}px
  );
  flex-shrink: 0;
`;
